import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import EfAccordionCards, { EfAccordionCardType } from '@elem/ui/ef-accordion-cards';
import { PageNavType } from '../PageNav';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function TheComp() {
    const { useLang } = useGlobal();
    const { t } = useLang('theProduct.ReliableUPS');
    const list: EfAccordionCardType[] = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732183838633/01.jpg',
            title: t('card1_title'),
            desc: t('card1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732183847684/02.jpg',
            title: t('card2_title'),
            desc: t('card2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732183856129/03.jpg',
            title: t('card3_title'),
            desc: t('card3_desc'),
        },
    ];
    return (
        <div className={styles.TheComp} id={PageNavType.What}>
            <EfSpec />
            <EfSection hasAnimation={false} label={t('label')} title={t('subTitle')} desc={t('desc')} />
            <EfAccordionCards list={list} />
            <EfSpec />
        </div>
    );
}
